import {
    CREATE_STRIPE_PAYMENT_INTENT,
    CLEAR_STRIPE_PAYMENT_INTENT,
    REGISTER_STRIPE_READER,
    UPDATE_STRIPE_READER_STATUS
} from 'shared/actions/types'

import produce from 'immer';

const initialState = {
    terminal: null,
    terminalDetails: null,
    terminalPaymentData: null,
    connectionStatus: ''
}

export default function (state = initialState, action) {
    switch (action.type) {
        case REGISTER_STRIPE_READER:
            return produce(state, draft => {
                draft.terminalDetails = action.payload;
            })
        case CREATE_STRIPE_PAYMENT_INTENT:
            return produce(state, draft => {
                draft.terminalPaymentData = action.payload;
            })
        case CLEAR_STRIPE_PAYMENT_INTENT:
            return produce(state, draft => {
                draft.terminalPaymentData = null;
            })
        case UPDATE_STRIPE_READER_STATUS:
            return produce(state, draft => {
                draft.connectionStatus = action.payload;
            })
        default:
            return state;
    }
}